import Store from '@/store/'

export const buildFetchForShop = (Model, options = null) => {
  let shopId = Store.getters['shop/getShopId']
  let uri = `/shops/${shopId}/${Model.uri_path || Model.entity}`
  if (options) {
    let filterQuery = ''
    if (options.filters) {
      let filtersObj = options.filters

      filterQuery = Object.keys(filtersObj).map(
        (key) => `&filter[${key}]=${filtersObj[key]}`
      )
      delete options.filters
    }
    uri += `?` + new URLSearchParams(options).toString() + filterQuery
  }

  return Model.api().get(uri, { dataKey: 'data' })
}

export const buildCreateModelForShop = (Model, fields) => {
  let shopId = Store.getters['shop/getShopId']
  let uri = `/shops/${shopId}/${Model.uri_path || Model.entity}`

  return Model.api().post(uri, fields, { dataKey: 'data' })
}

export const buildCreateOrUpdateModelForShop = (Model, id) => {
  let entity = Model.find(id)
  if (entity.$isNew) {
    return buildCreateModelForShop(Model, entity)
  } else {
    return buildUpdateModel(Model, id, entity)
  }
}

export const buildFetchById = (Model, modelId) => {
  let shopId = Store.getters['shop/getShopId']
  let uri = `/shops/${shopId}/${Model.uri_path || Model.entity}/${modelId}`

  return Model.api().get(uri, { dataKey: 'data' })
}

export const buildUpdateModel = (Model, modelId, fields) => {
  let shopId = Store.getters['shop/getShopId']

  return Model.api().patch(
    `/shops/${shopId}/${Model.uri_path || Model.entity}/${modelId}`,
    fields,
    { dataKey: 'data' }
  )
}
export const buildDeleteModel = (Model, modelId) => {
  if (typeof modelId === 'undefined') {
    return Promise.reject('You must provide a modelId to delete.')
  }
  return Model.api().delete(`/${Model.uri_path || Model.entity}/${modelId}`, {
    delete: modelId,
  })
}

export const buildSearchInShop = (Model, search) => {
  let shopId = Store.getters['shop/getShopId']
  let uri = `/shops/${shopId}/${Model.uri_path ||
    Model.entity}?search=${search}`

  return Model.api().get(uri, { dataKey: 'data' })
}
